(function () {
    'use strict';

    /*
     UserChangePasswordController Module
    -------------------------------------------------------------------------- */

    angular
        .module('UserApp.changePassword', [])

        /**
          * UserChangePasswordController - change user password
          *
          * @inject __Form
          * @inject appServices
          * 
          * @return void
          *-------------------------------------------------------- */

        .controller('UserChangePasswordController', [
            '__Form',
            'appServices',
            '__Utils',
            '$state',
            function (__Form, appServices, __Utils, $state) {

                var scope = this;

                scope = __Form.setup(scope, 'user_password_update_form', 'userData', {
                    secured: true
                });

                /**
                  * Submit update password form action
                  *
                  * @return void
                  *---------------------------------------------------------------- */

                scope.submit = function () {

                    __Form.process('user.change_password.process', scope)
                        .success(function (responseData) {

                            appServices.processResponse(responseData, null, function () {
                                scope.userData = {};

                                if (document.location.href == responseData.data.passwordRoute) {
                                    window.location = window.appConfig.appBaseURL;
                                } else {
                                    $state.go('dashboard');
                                }

                            });

                        });

                };

            }
        ]);

})();